import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/outline'
import React, { Fragment, useState, useEffect } from 'react'

interface IListProps {
  items: { key: string; value: string }[]
  onItemSelected: (key: string) => void
}

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}

export default function ListBox({ items, onItemSelected }: IListProps) {
  const [query, _setQuery] = useState('')
  const [selectedItem, setSelectedItem] = useState<{ key: string; value: string }>()

  const filteredItems =
    query === ''
      ? items
      : items.filter(item => {
          return item.value.toLowerCase().includes(query.toLowerCase())
        })

  console.log('FILTERED ITEMS', filteredItems)

  const handleSelectedItem = (item: any) => {
    setSelectedItem(item)
    onItemSelected(item)
  }

  useEffect(() => {
    if (items?.length > 0 && !selectedItem) {
      handleSelectedItem(items[0].key)
    }
  }, [items])

  return (
    <Listbox value={selectedItem} onChange={handleSelectedItem}>
      <div className="relative mt-1">
        <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm">
          <span className="block truncate capitalize">{selectedItem}</span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </span>
        </Listbox.Button>
        <Transition as={Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
          <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            {filteredItems.map(item => (
              <Listbox.Option
                key={item.key}
                className={({ active }) =>
                  `relative cursor-default select-none py-2 pl-10 pr-4 ${
                    active ? 'bg-primary text-white' : 'text-gray-900'
                  }`
                }
                value={item.value}
              >
                {({ selected }) => (
                  <>
                    <span className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}>{item.value}</span>
                    {selected ? (
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-secondary">
                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                      </span>
                    ) : null}
                  </>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  )
}
